"use client";

import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { hardcodedContent } from "@/app/(site)/_lib/global-content";
import { PlainBlock, SingleNewsPageQueryResult } from "@/sanity.types";
import PlainBlockRenderer from "../../../utils/plain-block-renderer/PlainBlockRenderer";

type ReferencesToArticleProps = {
	value: NonNullable<SingleNewsPageQueryResult>["references"];
};

export default function ReferencesToArticle({ value }: ReferencesToArticleProps) {
	const [isExpanded, setIsExpanded] = useState(false);

	const toggleExpanded = () => {
		setIsExpanded(!isExpanded);
	};

	return (
		<div className="mt-16 sm:mt-16">
			<p className="text-cap-m text-brown-middle mb-5 sm:mb-10">{hardcodedContent.singleNewsPage.references}</p>

			<div className="relative">
				{/* Content container */}
				<motion.div
					className="text-brown-middle mb-5 flex flex-col gap-y-5 overflow-hidden sm:mb-10"
					initial={{ height: "auto" }}
					animate={{
						height: isExpanded ? "auto" : "120px",
					}}
					transition={{
						duration: 0.6,
						ease: [0.25, 0.46, 0.45, 0.94],
					}}
				>
					<PlainBlockRenderer value={value as PlainBlock} />
				</motion.div>

				{/* Fog overlay */}
				<AnimatePresence>
					{!isExpanded && (
						<motion.div
							className="pointer-events-none absolute right-0 bottom-0 left-0"
							style={{
								background:
									"linear-gradient(0deg, #FFF 0%, rgba(255, 255, 255, 0.94) 5.65%, rgba(255, 255, 255, 0.00) 100%)",
								height: "60px",
							}}
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
							transition={{
								duration: 0.4,
								ease: "easeInOut",
							}}
						/>
					)}
				</AnimatePresence>
			</div>

			<motion.button
				className="text-cap-l text-brown-middle hover:text-brown cursor-pointer transition-colors duration-300"
				onClick={toggleExpanded}
				whileHover={{ scale: 1.02 }}
				whileTap={{ scale: 0.98 }}
				transition={{ duration: 0.2 }}
			>
				{isExpanded ? hardcodedContent.singleNewsPage.showLess : hardcodedContent.singleNewsPage.showMore}
			</motion.button>
		</div>
	);
}
